import React, { useState } from "react";

import { Icon, Menu } from "semantic-ui-react";

import UserPanel from "./UserPanel";
import Starred from "./Starred";
import Channels from "./Channels";
import DirectMessages from "./DirectMessages";

const SidePanel = ({ currentUser, channels }) => {
    const [show, setShow] = useState(false);
    const [activeChannel, setActiveChannel] = useState(channels.currentChannel?.id || "");

    return (
        <Menu size="large" inverted fixed="left" vertical className={`side-panel ${show ? "show" : ""}`}>
            <Icon name={show ? "close" : "bars"} className="side-panel--toggler-btn" onClick={() => setShow(!show)} />

            <UserPanel currentUser={currentUser} />

            <Starred channels={channels} activeChannel={activeChannel} setActiveChannel={setActiveChannel} />

            <Channels
                currentUser={currentUser}
                channels={channels}
                activeChannel={activeChannel}
                setActiveChannel={setActiveChannel}
            />

            <DirectMessages activeChannel={activeChannel} setActiveChannel={setActiveChannel} />
        </Menu>
    );
};

export default SidePanel;
